import router from "@/shared/router";

const mainRoute = router.options.routes.find(r => r.path === '/');

import {routes as authRoutes} from './auth/auth';
import {routes as setupRoutes} from './setup/Setup.module';
import {routes as DocRoutes} from '@/modules/docs/Doc.module';
import {routes as customerRoutes} from './customer/Customer.module';
import {routes as receiptRoutes} from './receipt/Receipt.module';
import {routes as salesRoutes} from './sales/Sales.module';
import {routes as auctionsRoutes} from './auctions/Auctions.module';
import {routes as liveBidsRoutes} from './live-bids/LiveBids.module';
import {routes as llpRoutes} from './live-lots-performance/LiveLotsPerformance.module';
import {routes as commonRoutes} from './common/Common.module';
import {routes as marketingRoutes} from './marketing/Marketing.module';
import {routes as financeRoutes} from './finance/Finance.module';
import {routes as itemsRoutes} from './items/Items.module';
import {routes as reportsRoutes} from './reports/Reports.module';
import {routes as notificationActivityRoutes} from './notification-activity/NotificationActivity.module';
import {routes as reservationsRoutes} from './reservations/Reservations.module'
import {routes as featureRequestRoutes} from './feature-request/FeatureRequest.module'
import ConditionReportRequest from './condition-report-requests/ConditionReportRequest.module'
import TransferNote from './transfer-notes/TransferNote.module'
import {routes as dpvRoutes} from './dpv/Dpv.module'
import {routes as apiUsageRoutes} from './api-usage/ApiUsage.module'

let allRoutes = [
  ...authRoutes,
  ...customerRoutes,
  ...receiptRoutes,
  ...salesRoutes,
  ...liveBidsRoutes,
  ...llpRoutes,
  ...commonRoutes,
  ...marketingRoutes,
  ...reportsRoutes,
  ...notificationActivityRoutes,
  ...setupRoutes,
  ...auctionsRoutes,
  ...financeRoutes,
  ...itemsRoutes,
  ...reservationsRoutes,
  ...ConditionReportRequest.routes,
  ...dpvRoutes,
  ...featureRequestRoutes,
  ...apiUsageRoutes,
  ...TransferNote.routes,
  ...DocRoutes
]

allRoutes.forEach((obj) => {
  mainRoute.children.push(obj);
});

router.addRoutes([mainRoute]);
